export default __webpack_public_path__ + "static/media/popup_sf2.9013d57a.png";